<template>
  <div class="flex items-center justify-center h-full">
    <DropdownMenu>
      <DropdownMenuItem @click="runTask">Run</DropdownMenuItem>
      <DropdownMenuItem @click="editPreferences">Edit Preferences</DropdownMenuItem>
      <DropdownMenuItem @click="deleteTask">Delete</DropdownMenuItem>
    </DropdownMenu>
  </div>
</template>

<script>
import DropdownMenu from '@/components/widgetcomponents/ui/DropdownMenu.vue'
import DropdownMenuItem from '@/components/widgetcomponents/ui/DropdownMenuItem.vue'

export default {
  name: 'TaskActionsCell',
  components: {
    DropdownMenu,
    DropdownMenuItem,
  },
  props: {
    params: {
      type: Object,
      required: true,
    },
  },
  methods: {
    runTask() {
      this.params.context.componentParent.runSingleTask(this.params.data.id)
    },
    editPreferences() {
      this.params.context.componentParent.openEditPreferences(this.params.data.id)
    },
    deleteTask() {
      this.params.context.componentParent.deleteSingleTask(this.params.data.id)
    },
  },
}
</script>
